import { Controller, useFormContext } from "react-hook-form";
import { ErrorMessage, Toggle, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { AddClientFormData } from "../types";

export const SendLoginInstructionsField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<AddClientFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Send Login Instructions</Typography>
      <Controller
        name="sendLoginInstructions"
        control={control}
        render={({ field }) => (
          <div className="mt-1 flex items-center gap-4">
            <Toggle checked={field.value} onChange={(checked) => field.onChange(checked)} />
            <Typography className="inline">{field.value ? "Yes" : "No"}</Typography>
          </div>
        )}
      />
      <ErrorMessage errors={errors} name="sendLoginInstructions" />
    </div>
  );
};
